// generated by genversion
module.exports = '3.36.0';



//////////////////
// WEBPACK FOOTER
// ./src/utils/version.js
// module id = 1016
// module chunks = 0